<script setup>
import SCardWithToolbar from '@/components/global/s-card-with-toolbar.vue'
import AjustementListItem from '@/components/fiche-aim/fiche-aim/ajustement/ajustement-list-item.vue'
import CreationAjustementCard from '@/components/fiche-aim/fiche-aim/ajustement/creation-ajustement-card.vue'
import CreationDetteFromBs from '@/components/fiche-aim/fiche-aim/ajustement/creation-dette-form-bs.vue'
import EpargneFormBs from '@/components/fiche-aim/fiche-aim/ajustement/epargne-form-bs.vue'
</script>

<template ref="ajustementVue">
  <s-card-with-toolbar :loading="loading" id="aj-card">
    <template #titre>Ajustements</template>
    <template #default>
      <div class="h-100">
        <v-row no-gutters class="h-100">
          <v-col cols="12" class="h-100">
            <perfect-scrollbar class="h-100">
              <v-list>
                <ajustement-list-item
                  :read-only="readOnly"
                  v-for="ajustement in ajustements"
                  :key="ajustement.ajustementId"
                  :ajustement="ajustement"
                  @modifier="(ajustementAModif) => modifierAjustement(ajustementAModif)"
                  @delete="envoyerCommandeRetirerAjustement(ajustement.ajustementId)"
                />
              </v-list>
            </perfect-scrollbar>
          </v-col>
        </v-row>
      </div>
      <creation-ajustement-card
        :active="creationDrawer"
        :fiche-aim-id="ficheAimId"
        @created="() => (creationDrawer = false)"
        @close="() => (creationDrawer = false)"
      />
      <creation-dette-from-bs
        :active="detteDrawer"
        :fiche-aim-id="ficheAimId"
        @created="() => (detteDrawer = false)"
        @close="() => (detteDrawer = false)"
      />
      <epargne-form-bs
        :active="epargneDrawer"
        :fiche-aim-id="ficheAimId"
        @created="() => (epargneDrawer = false)"
        @close="() => (epargneDrawer = false)"
      />
    </template>
    <template #bottom>
      <v-card>
        <v-card-actions>
          <v-spacer />
          <v-btn color="primary" @click="() => (epargneDrawer = true)" :disabled="readOnly">
            <v-icon class="pr-2">mdi-piggy-bank</v-icon>
            Épargner
          </v-btn>
          <v-btn color="primary" @click="() => (detteDrawer = true)" :disabled="readOnly">
            <v-icon class="pr-2">mdi-hand-coin</v-icon>
            Créer une dette
          </v-btn>
          <v-btn color="primary" @click="() => (creationDrawer = true)" :disabled="readOnly">
            <v-icon class="pr-2">mdi-plus</v-icon>
            Créer un ajustement
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </s-card-with-toolbar>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'ajustements-aim',
  data() {
    return {
      loading: false,
      creationDrawer: false,
      detteDrawer: false,
      epargneDrawer: false,
    }
  },
  props: {
    ajustements: {
      type: Array,
      required: true,
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters({
      getPosteById: 'posteAIM/findPosteById',
    }),
    ficheAimId() {
      return parseInt(this.$route.params.ficheAimId, 10)
    },
  },
  methods: {
    ...mapActions({
      fetchPostes: 'posteAIM/fetchPostes',
      ajusterFicheAIM: 'ficheAIM/ajusterFicheAIM',
      retirerAjustement: 'ficheAIM/retirerAjustement',
    }),
    formaterCommandeAjusterFiche(ajustementAvecModifications) {
      console.log('formateee', ajustementAvecModifications)
      let ops = []
      ajustementAvecModifications.operations.forEach((op) =>
        ops.push({
          posteAIMId: op.posteAIM.posteAIMId,
          montant: op.montant,
        })
      )
      return {
        ficheAIMId: this.ficheAimId,
        operations: ops,
        explication: ajustementAvecModifications.explication,
      }
    },
    envoyerCommandeAjusterFiche(ajustementAvecModifications) {
      this.loading = true
      this.ajusterFicheAIM(this.formaterCommandeAjusterFiche(ajustementAvecModifications)).then(() =>
        this.fallbackToDefaultState()
      )
    },
    envoyerCommandeRetirerAjustement(ajustementId) {
      this.loading = true
      this.retirerAjustement({
        ficheAIMId: this.ficheAimId,
        ajustementId: ajustementId,
      }).then(() => this.fallbackToDefaultState())
    },
    modifierAjustement(ajustementAvecModifications) {
      this.loading = true
      this.retirerAjustement({
        ficheAIMId: this.ficheAimId,
        ajustementId: ajustementAvecModifications.ajustementId,
      }).then(() => this.envoyerCommandeAjusterFiche(ajustementAvecModifications))
    },
    fallbackToDefaultState() {
      this.loading = false
    },
  },
  created() {
    this.fetchPostes()
  },
}
</script>

<style>
.fixed-height {
  display: flex;
  flex-direction: column;
  height: 100%;
  max-height: 100%;
  overflow: hidden;
}
textarea {
  height: 100px !important;
}
</style>
